import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import NavBar from './components/NavBar';
import RequireAuth from './components/RequireAuth';
import WeekPlanner from './pages/WeekPlanner';
import DishLibrary from './pages/DishLibrary';
import DishForm from './pages/DishForm';
import Products from './pages/Products';
import ProductForm from './pages/ProductForm';
import ShoppingList from './pages/ShoppingList';
import Progress from './pages/Progress';
import Upgrade from './pages/Upgrade';
import Onboarding from './pages/Onboarding';
import Settings from './pages/Settings';
import ContactUs from './pages/ContactUs';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { AuthProvider } from './context/AuthContext';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <NavBar />
          <main style={{ maxWidth: 720, margin: '0 auto', padding: '1rem' }}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              <Route element={<RequireAuth />}>
                <Route path="/" element={<WeekPlanner />} />
                <Route path="/dishes" element={<DishLibrary />} />
                <Route path="/dishes/new" element={<DishForm />} />
                <Route path="/dishes/:id/edit" element={<DishForm />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/new" element={<ProductForm />} />
                <Route path="/products/:id/edit" element={<ProductForm />} />
                <Route path="/shopping-list" element={<ShoppingList />} />
                <Route path="/progress" element={<Progress />} />
                <Route path="/upgrade" element={<Upgrade />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/contact" element={<ContactUs />} />
              </Route>
            </Routes>
          </main>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
